import { render, staticRenderFns } from "./newTopCreator.vue?vue&type=template&id=4cb158ae&scoped=true&"
import script from "./newTopCreator.vue?vue&type=script&lang=js&"
export * from "./newTopCreator.vue?vue&type=script&lang=js&"
import style0 from "./newTopCreator.vue?vue&type=style&index=0&id=4cb158ae&scoped=true&lang=scss&"
import style1 from "./newTopCreator.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb158ae",
  null
  
)

export default component.exports